import MarketSiteRegionsV2 from './MarketSiteRegionsv2';
import SitesLocalStorageService from './sitesLocalStorageService'
import storage from './storage.js';
import GeoIPService from './geoipService';
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace GeoIPMarketRedirectV2
 */
export default class GeoIPMarketRedirectV2 {
    constructor(_geoIPData) {
        this.COUNTRY_COOKIE_KEY = "countryCode";
        this.REGION_COOKIE_KEY = "regionCode";
        this.DEFAULT_REDIRECT_PAGE = "/home.html";
        this.geoipData = _geoIPData;
        this.countryCookie = SitesLocalStorageService.getItem(this.COUNTRY_COOKIE_KEY);
        this.regionCode = SitesLocalStorageService.getItem(this.REGION_COOKIE_KEY);
        this.languageCookie = this.getLanguage();
    }

    //PUBLIC FUNCTIONS
    getLanguage() {
        let locale = navigator.language;
        let locationArray = locale.split('-');
        if(locationArray.length > 0){
            return locationArray[0];
        }
        return "";
    }

    async getMarketSiteRedirect() {
        let deferred = $.Deferred();
        if (this.countryCookie && this.languageCookie && this.regionCode) {
            this.processMarketSiteRedirect(this.languageCookie, this.countryCookie, this.regionCode, false, deferred);
        }  else {
            if (this.geoipData) {
                if (this.geoipData.error) {
                    this.onMarketError(geopiData.error, deferred);
                }
                this.onMarketSuccess(this.geoipData, deferred);
            } else {
                const country = await GeoIPService.getAllCountry();
                if (country.error) {
                    this.onMarketError(country.error, deferred);
                } else {
                    this.geoipData = country;
                    this.onMarketSuccess(country, deferred);
                }
            }
        }
        return deferred.promise();
    }

    //PRIVATE FUNCTIONS

    onMarketSuccess(geoipResponse, deferred) {
        const trustArc = JSON.parse(localStorage.getItem('truste.eu.cookie.notice_gdpr_prefs'));
        const EU = 'europe';
        let country = geoipResponse.country.iso_code;
        let isEU = geoipResponse.country.is_in_european_union || false;
        let locale = navigator.language;
        let locationArray = locale.split('-');
        let language = "";
        if(locationArray.length > 0){
            language = locationArray[0];
        }
        MarketSiteRegionsV2.getMarketSiteRegionByCountry(country).then(regionCode => {
            if (!isEU || (isEU && trustArc && storage.isAllowed('Functional'))) {
                this.saveCookieData(country, regionCode);
            }
            this.processMarketSiteRedirect(language, country, regionCode, isEU, deferred);
        });
    }

    onMarketError(geoipError, deferred) {
        console.log("GeoIP Lookup error: ", geoipError);
        this.processMarketSiteRedirect(this.languageCookie, "US", "unknown", false, deferred);
    }

    processMarketSiteRedirect(language, country, regionCode, isEU = false, deferred) {
        let marketName;
        let marketUrl;
        MarketSiteRegionsV2.getMarketSiteRegionData(true).then(data => {
            let count = 0;
            let regionLength = data.length;
            data.map(region => {
                if (region.hasOwnProperty("countryname")) {
                    region.countryname.map(market => {
                        if (market.hasOwnProperty("countryCode") && country === market.countryCode) {
                            if (market.hasOwnProperty("locale_names")) {
                                //Grab translated country
                                if (market.locale_names.hasOwnProperty(language)) {
                                    marketName = market.locale_names[language];
                                }
                                // If translated country wasn't found grab first one in list
                                if (!marketName) {
                                    if (market.hasOwnProperty("defaultLocale") && market.defaultLocale.hasOwnProperty("defaultLanguageCode")) {
                                        marketName = market.defaultLocale.defaultLanguageCode;
                                    } else {
                                        //If none in list default to United States
                                        marketName = "United States";
                                    }
                                }
                            } else {
                                deferred.reject("No locale_names for given market");
                            }

                            if (market.hasOwnProperty("paths")) {
                                if (market.paths.hasOwnProperty(language)) {
                                    marketUrl = market.paths[language];
                                }

                                if (!marketUrl) {
                                    if (market.hasOwnProperty("defaultLocale") && market.defaultLocale.hasOwnProperty("defaultLanguageCode")) {
                                        let defaultLanguageCode = market.defaultLocale.defaultLanguageCode;
                                        if (market.paths.hasOwnProperty(defaultLanguageCode)) {
                                            marketUrl = market.paths[defaultLanguageCode];
                                        }
                                    }

                                    if (!marketUrl) {
                                        marketUrl = "/content/nuskin/en_US" + this.DEFAULT_REDIRECT_PAGE;
                                    }
                                }
                            } else {
                                deferred.reject("No paths for given market");
                            }

                            deferred.resolve({
                                regionName: regionCode,
                                marketName: marketName,
                                marketUrl: marketUrl,
                                languageCode: language,
                                countryCode: country,
                                regions: data,
                                isEU: isEU
                            });
                        }


                    });
                }
                count++;
            });

            if (count === regionLength && !marketName && !marketUrl) {
                deferred.reject({
                    countryCode: country,
                    languageCode: language,
                    isEU: isEU,
                    regions: data,
                    regionName: regionCode
                });
            }
        });
    }

    saveCookieData(country, region) {
        SitesLocalStorageService.writeItem(this.COUNTRY_COOKIE_KEY, country);
        SitesLocalStorageService.writeItem(this.REGION_COOKIE_KEY, region);
    }

}
